"use strict";
/**
 * AngularJS button list component.
 *
 * @packageDocumentation
 * @module ButtonList
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = require("../../base");
var button_list_controller_1 = require("./button-list.controller");
//#region Asset Imports
var button_list_tpl_html_1 = tslib_1.__importDefault(require("./button-list.tpl.html"));
require("./button-list.scss");
//#endregion
//#region Consts
exports.COMPONENT_NAME = 'imrButtonList';
//#endregion
//#region Setup
var IMRButtonListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(IMRButtonListComponent, _super);
    function IMRButtonListComponent() {
        return _super.call(this, {
            controller: button_list_controller_1.IMRButtonListController,
            template: button_list_tpl_html_1.default
        }) || this;
    }
    return IMRButtonListComponent;
}(base_1.IMRBaseComponent));
exports.IMRButtonListComponent = IMRButtonListComponent;
//#endregion
//# sourceMappingURL=button-list.component.js.map